module.exports = __webpack_public_path__ + "static/suspendedthoughts-04985464918411bdda5a3db5e60f4d33.png";